import * as React from "react";
import { ApiSelectedFixedComment, SelectedFixedCommentMeta } from "../../../../misc/api/FixedComments/apiTypes";
import AsyncFixedComments from "./AsyncFixedComments";
import Loading from "../../../../misc/components/loading";

interface AsyncFixedCommentsButtonProps {

    fetchComments: () => Promise<SelectedFixedCommentMeta[]>;
    updateComments?: (commentMutations: ApiSelectedFixedComment[]) => Promise<void>;
    onClose?: () => void;
    header: string;
    isReadOnly: boolean;
    buttonText: string;
}

const AsyncFixedCommentsButton = ({ fetchComments, header, onClose, updateComments, isReadOnly, buttonText }: AsyncFixedCommentsButtonProps): JSX.Element => {

    const [modalActive, setModalActive] = React.useState<boolean>(false);
    const [commentMetadata, setCommentMetadata] = React.useState<SelectedFixedCommentMeta[]>();
    const [isBusy, setIsBusy] = React.useState<boolean>(false);
    const [errors, setErrors] = React.useState();

    const handleClose = () => {
        setModalActive(false);
        onClose && onClose();
    };

    React.useEffect(() => {

        async function GetComments() {

            if (modalActive) {
                return;
            }

            setErrors(undefined);
            setIsBusy(true);

            try {
                const commentData = await fetchComments();
                setCommentMetadata(commentData);
            } catch (error) {
                setErrors(error);
            } finally {
                setIsBusy(false);
            }
        }
        GetComments();

    }, [modalActive]);

    return (commentMetadata ? <>
        <button className="btn btn-primary" onClick={(e) => {
            e.preventDefault();
            setModalActive(true);
        }}>
            <ButtonContent buttonText={buttonText} commentMetadata={commentMetadata} />
        </button>
        {modalActive ? <AsyncFixedComments commentMetadata={commentMetadata} header={header} onClose={handleClose} updateComments={isReadOnly ? null : updateComments} /> : null}
    </> : null);
};

interface ButtonContentProps {
    buttonText: string;
    commentMetadata: SelectedFixedCommentMeta[];
}

const ButtonContent = ({ buttonText, commentMetadata }: ButtonContentProps): JSX.Element => {

    const selectedComments = commentMetadata.filter(cm => cm.IsSelected);

    return (!!commentMetadata ? <>
        {buttonText}&nbsp;<span className="badge badge-info">
            {selectedComments.length}
        </span>
    </> : <Loading /> )
    };

    export default AsyncFixedCommentsButton;
